import { SxProps } from '@mui/material';
import { ImageAsset as TImageAsset } from '@/types/generated';
import FocalPointImage from '../FocalPointImage';
import ImageAsset from '../ImageAsset';
import { BlogImage } from '@shared-components/components/BlogDetailsPage';
import { IImage } from '@shared-components/components/ImageAsset/ImageAsset';
export interface IBlogImage {
  imageAsset: TImageAsset;
  blogImage: BlogImage;
  imageAssetStyles?: SxProps;
  blogImageStyles?: SxProps;
  dataTestId: string;
}
const BlogImageCondition = ({
  imageAsset,
  imageAssetStyles,
  blogImage,
  blogImageStyles,
  dataTestId
}: IBlogImage) => {
  if (imageAsset) {
    return <ImageAsset desktopImage={imageAsset?.desktopImage as IImage} mobileImage={imageAsset?.mobileImage as IImage} imageSx={imageAssetStyles} dataTestId={dataTestId} />;
  }
  if (blogImage) {
    return <FocalPointImage brandFolderImage={blogImage?.image} focalPoint={blogImage?.focalPoint} imageSx={blogImageStyles} dataTestId={dataTestId} />;
  }
  return null;
};
export default BlogImageCondition;